class CustomerPropertyInfo {

    constructor($scope) {
        this.$scope = $scope;
    }

    $onInit() {
        this.$scope.selectedContact = this.customer;
    }
}

export const CUSTOMER_PROPERTY_INFO = ["$scope", CustomerPropertyInfo];